import { useDeleteFileMutation } from "apollo/hooks/mutations";
import { useGetFilesLazyQuery } from "apollo/hooks/queries";
import { FILE_SCOPE, FILE_SHARE_MODE_NONE } from "core/consts";
import { getErrorMessage } from "core/model/utils/errors";
import {
  Auction,
  ClinicalConsultation,
  Patient,
  RecareFileType,
} from "core/types";

export const useDeleteUnsharedFileByType = ({
  auctionId,
  consultationId,
  patientId,
  recareFileType,
}: {
  auctionId: Auction["id"];
  consultationId?: ClinicalConsultation["id"];
  patientId?: Patient["id"];
  recareFileType: RecareFileType;
}) => {
  let params;
  if (consultationId) {
    params =
      `clinical_consultation_id=${consultationId}&scope=${FILE_SCOPE.PATIENT_FILES}` as const;
  } else if (patientId) {
    params =
      `patient_id=${patientId}&auction_id=${auctionId}&scope=${FILE_SCOPE.PATIENT_FILES}` as const;
  } else {
    params =
      `auction_id=${auctionId}&scope=${FILE_SCOPE.PATIENT_FILES}` as const;
  }
  const [getFilesLazy] = useGetFilesLazyQuery({ params });

  const [deleteBEFile] = useDeleteFileMutation({});

  const deleteUnsharedFile = async () => {
    const { data } = await getFilesLazy({ params });
    const files = data?.files;

    const matchingFile = files?.find(
      ({ recare_file_type, share_mode }) =>
        recare_file_type === recareFileType &&
        share_mode === FILE_SHARE_MODE_NONE,
    );

    if (matchingFile) {
      try {
        await deleteBEFile(undefined, {
          id: matchingFile.id,
          params,
        });
      } catch (fileDeleteErr) {
        console.error(
          `Error deleting backend file: ${getErrorMessage(fileDeleteErr)}`,
        );
      }
    }
  };

  return { deleteUnsharedFile };
};
